import get from 'lodash/get'
import { getFormInitialValues, formValueSelector, getFormMeta } from 'redux-form'

export const isFieldDirty = (formName) => (state, fieldName) => {
  const fieldInitValue = getFormInitialValues(formName)(state)[fieldName]
  const fieldValue = formValueSelector(formName)(state, fieldName)

  return fieldInitValue !== fieldValue
}

export const isFieldTouched = (formName) => (state, fieldName) => {
  const formMeta = getFormMeta(formName)(state)
  return get(formMeta, `[${fieldName}].touched`, false)
}
